module.exports = {
  version: process.env.NOW_BITBUCKET_COMMIT_SHA || "default",
};
